<template>
  <slot />

  <AffiliateTransactions
    :modelValue="affiliateStore.isOpenAffiliateTransactionsModal"
    @update:model-value="affiliateStore.toggleAffiliateTransactionsModal"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import useAffiliateStore from '@/modules/Affiliate/store'

const AffiliateTransactions = defineAsyncComponent(
  () =>
    import(
      '@/modules/Affiliate/components/AffiliateTransactions/AffiliateTransactions.vue'
    )
)

const affiliateStore = useAffiliateStore()
</script>
